import { map, unionBy, isEmpty, filter } from "lodash";
import { LOGOUT, GET_CHATS_H, GET_CHAT_DETAILS, SET_CURRENT_CHATH, GET_REMAINING_MESSAGES } from "@Actions/types";

export default function reducer(
	state = {
		chats: [],
		messages: [],
		currentChatId: 0,
	},
	action
) {
	const { type, payload } = action;
	switch (type) {
		case LOGOUT: {
			return {
				...state,
				chats: [],
				messages: [],
				currentChatId: 0,
			};
		}

		case GET_CHATS_H: {
			const chatIds = new Set(
				map(payload.data.chats, (item) => {
					return item.id;
				})
			);
			const preservedMessages = filter(state.messages, (item) => {
				return chatIds.has(item.chatId);
			});
			const previewMessages = map(payload.data.messages, (item) => {
				return { ...item, status: "read" };
			});
			return {
				...state,
				chats: map(payload.data.chats, (item) => {
					const existing = state.chats.find((chat) => {
						return chat.id === item.id;
					});
					return {
						...item,
						hasFetched: existing?.hasFetched ?? false,
						endFetching: existing?.endFetching ?? false,
						count: 0,
					};
				}),
				messages: unionBy(previewMessages, preservedMessages, "id"),
				currentChatId: 0,
			};
		}

		case SET_CURRENT_CHATH: {
			return {
				...state,
				chats: map(state.chats, (item) => {
					if (item.id === payload.data.chatId) return { ...item, count: 0 };
					return item;
				}),
				currentChatId: payload.data.chatId,
			};
		}

		case GET_CHAT_DETAILS: {
			if (payload.data.isHistoric) {
				const existing = state.chats.find((item) => {
					return item.id === payload.data.chat.id;
				});
				if (existing) {
					return {
						...state,
						chats: map(state.chats, (item) => {
							if (item.id === payload.data.chat.id) return { ...item, ...payload.data.chat };
							return item;
						}),
					};
				}
				return {
					...state,
					chats: [...state.chats, payload.data.chat],
				};
			}
			return state;
		}

		case GET_REMAINING_MESSAGES: {
			if (payload.data.isHistoric) {
				const mergedMsgs = unionBy(state.messages, payload.data.messages, "id");
				const mappedMsgs = map(mergedMsgs, (item) => {
					return { ...item, status: "read" };
				});
				const mappedChats = map(state.chats, (item) => {
					if (item.id === payload.data.chatId) return { ...item, hasFetched: true, endFetching: isEmpty(payload.data.messages) };
					return item;
				});
				return {
					...state,
					chats: mappedChats,
					messages: mappedMsgs,
				};
			}
			return { ...state };
		}

		default:
			return state;
	}
}
